@if(form()){
<div [formGroup]="form()">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title"
        >RECOMMENDATION TASK to the attention of
        {{ form().get('assessmentCoordinator')?.value | userName: form().get('assessmentCoordinatorName')?.value | async }}
        {{ form().get('assessmentCoordinator')?.value | azureIdStatus | async }}</mat-card-title
      >
    </mat-card-header>
    <div class="cardContainer">
      <mat-form-field class="box">
        <mat-label>ID</mat-label>
        <input
          matInput
          formControlName="recommendationId" />
      </mat-form-field>
      <mat-form-field class="box">
        <mat-label>Priority</mat-label>
        <input
          matInput
          formControlName="priority" />
      </mat-form-field>
      @if(form().get('currentDeadlineDate')?.value){
      <!-- TODO bitte pipe für MS Dates kopieren -->
      <mat-form-field
        class="box"
        [ngClass]="overdue">
        <mat-label>Actual deadline</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="currentDeadlineDate" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      }

      <mat-form-field class="box">
        <mat-label>Status</mat-label>
        <mat-select
          class="select"
          formControlName="status">
          <mat-option value="Pending">Pending</mat-option>
          <mat-option value="Settled">Settled</mat-option>
          <mat-option value="Pending & Overdue">Pending & Overdue</mat-option>
          @if (accessService.hasAuditorRole()) {
          <mat-option value="Finally settled">Finally settled</mat-option>
          <mat-option value="Adjourned">Adjourned</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="box">
        <mat-label>Budget in CHF</mat-label>
        <input
          formControlName="budget"
          matInput />
        <mat-error>Field has to be a number</mat-error>
      </mat-form-field>
      <mat-checkbox formControlName="isLegallyRequired">Legally Required</mat-checkbox>
    </div>
    <div>
      <p>Auditor's Recommendation Details</p>
      <app-editor
        [form]="form()"
        controlName="shortRemarkToAssessor" />
    </div>
    <p>Plant comments</p>
    <div class="middlecards">
      <app-editor
        [form]="form()"
        controlName="plantComments" />
    </div>
    <div class="middlecards">
      <mat-form-field class="full-width">
        <mat-label>Settle Reject reason</mat-label>
        <textarea
          matInput
          value="{{ form().get('settledRejectReason')?.value }}"
          disabled></textarea>
      </mat-form-field>
    </div>
  </mat-card>

  @if ( !isAuditor('GPIA') && !isStatus('Settled') && !isStatus('Finally settled') && (isProlongationStatus('Granted')
  || isProlongationStatus('Rejected')) ) {
  <mat-card>
    @if (checkDecision('1')) {
    <p class="prolong_text">The Prolongation request has been granted as required.</p>
    } @if (checkDecision('2')) {
    <p class="prolong_text">The new Deadline has been set to a Date defined by the Auditor.</p>
    } @if (checkDecision('0')) {
    <p class="prolong_text">The Prolongation request has been rejected!</p>
    }
    <div>
      @if (isProlongationStatus('Rejected')) {
      <div>
        <p>Prolongation reject Reason</p>
        <app-editor
          [form]="form()"
          controlName="prolongationToAssessor"
          [disabled]="true" />
      </div>
      }
      <mat-form-field>
        <mat-label>Prolongation granted Date</mat-label>
        <input
          matInput
          value="{{ form().get('prolongationGrantedDate')?.value }}"
          disabled />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Signature</mat-label>
        <input
          matInput
            value="{{ form().get('prolongationGrantedBy')?.value | userName: form().get('prolongationGrantedByName')?.value | async }} {{
            form().get('prolongationGrantedBy')?.value | azureIdStatus | async
          }}"
          disabled />
      </mat-form-field>
    </div>
  </mat-card>
  } @if (!isNew() && isStatus('Settled')) {
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title">SETTLED</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>Execution comment</p>
      <app-editor
        [form]="form()"
        controlName="commentExecution"
        [disabled]="true" />

      <div class="cardContainer">
        <mat-form-field class="titleRecommendation">
          <mat-label>Amount of CAPEX in CHF used:</mat-label>
          <input
            matInput
            value="{{ form().get('amountCapex')?.value }}"
            disabled />
        </mat-form-field>
        <mat-form-field class="titleRecommendation">
          <mat-label>Settled Date</mat-label>
          <input
            matInput
            value="{{ form().get('settledDate')?.value }}"
            disabled />
        </mat-form-field>
        <mat-form-field class="titleRecommendation">
          <mat-label>Signature</mat-label>
          <input
            matInput
            value="{{ form().get('settledBy')?.value | userName: form().get('settledByName')?.value | async }} {{
              form().get('settledBy')?.value | azureIdStatus | async
            }}"
            disabled />
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>
  } @if (!isNew() && isStatus('Finally settled')) {
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title">FINALLY SETTLED</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="cardContainer">
        <mat-form-field class="titleRecommendation">
          <mat-label>Finally Settled Date</mat-label>
          <input
            matInput
            value="{{ form().get('settledDateFinally')?.value }}"
            disabled />
        </mat-form-field>
        <mat-form-field class="titleRecommendation">
          <mat-label>Auditor</mat-label>
          <input
            matInput
            value="{{ form().get('settledByFinally')?.value | userName: form().get('settledByFinallyName')?.value | async }}"
            disabled />
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>
  } @if (!isNew() && isStatus('Adjourned')) {
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title">ADJOURNED</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="cardContainer">
        <mat-form-field class="titleRecommendation">
          <mat-label>Reason</mat-label>
          <input
            matInput
            value="{{ form().get('adjournedReason')?.value }}"
            disabled />
        </mat-form-field>
        <div class="middlecards">
          <mat-form-field class="box">
            <mat-label>Adjourned Date</mat-label>
            <input
              matInput
              value="{{ form().get('adjournedDate')?.value }}"
              disabled />
          </mat-form-field>
          <mat-form-field class="box">
            <mat-label>Signature</mat-label>
            <input
              matInput
              value="{{ form().get('adjournedBy')?.value | userName: form().get('adjournedByName')?.value | async }} {{
                form().get('adjournedBy')?.value | azureIdStatus | async
              }}"
              disabled />
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  } @if (!isAuditor('GPIA') && isProlongationStatus('Asked')) {
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title">PROLONGATION REQUEST</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="cardContainer">
        <div class="middlecards">
          <mat-form-field class="box">
            <mat-label>The reason for Prolongation is</mat-label>
            <input
              matInput
              value="{{ form().get('shortText2')?.value }}"
              disabled />
          </mat-form-field>
        </div>
        <div class="middlecards">
          <mat-form-field>
            <mat-label>Required new Deadline</mat-label>
            <input
              matInput
              value="{{ recommendations()?.prolongationDeadline }}"
              disabled />
          </mat-form-field>
        </div>
        <div class="middlecards">
          <mat-form-field>
            <mat-label>Date</mat-label>
            <input
              matInput
              value="{{ recommendations()?.prolongationRequestDate }}"
              disabled />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Signature</mat-label>
            <input
              matInput
              value="{{ form().get('prolongationRequestBy')?.value | userName: form().get('prolongationRequestByName')?.value | async }} {{
                form().get('prolongationRequestBy')?.value | azureIdStatus | async
              }}"
              disabled />
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  } @if (isStatus('Pending') || isStatus('Pending & Overdue')) {
  <mat-card>
    @if (!isProlongationStatus('Asked') && assessmentEditable()) {
    <button
      mat-raised-button
      (click)="openDialog()">
      My Assessment Feedback is...
    </button>
    } @if (isProlongationStatus('Asked') && auditorEditable()) {
    <button
      mat-raised-button
      (click)="openDialogProlo()">
      Answer Prolongation Request
    </button>
    }
  </mat-card>
  }
</div>
}
